import { render } from "./Pago_PagoImg.vue?vue&type=template&id=4a22db83"
import script from "./Pago_PagoImg.vue?vue&type=script&lang=js"
export * from "./Pago_PagoImg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__